module.exports = {
// GOOGLE_MAPS_API_KEY: "AIzaSyByoHs7jFtmD7GsZeFLpEbWg6pun0yWpos",
// GOOGLE_MAPS_API_KEY: "AIzaSyAez8FYEqIX0hkyai9jcJS_PS44NftwYyU",
GOOGLE_MAPS_API_KEY: "AIzaSyDQLXX7-K9om20wQPArnYMNsTm7EWKCG3g",
  LIBRARIES: ["places"],
};
